export interface CreateShelfTypeTempChangeFixRequest {
  shelfType: string
  shelfTypeOldUpdatedDateFrom: string
  shelfTypeOldUpdatedDateTo: string
  isShelfTypeOldUpdateDateRangeSearch: boolean
}

export function CreateShelfTypeTempChangeFixRequestToJSON(
  value: CreateShelfTypeTempChangeFixRequest
): any {
  return {
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    shelf_type_old_updated_date_from:
      value.shelfTypeOldUpdatedDateFrom !== ''
        ? value.shelfTypeOldUpdatedDateFrom
        : undefined,
    shelf_type_old_updated_date_to:
      value.shelfTypeOldUpdatedDateTo !== ''
        ? value.shelfTypeOldUpdatedDateTo
        : undefined,
    is_shelf_type_old_update_date_range_search:
      value.isShelfTypeOldUpdateDateRangeSearch ?? undefined
  }
}
